export default __webpack_public_path__ + "static/media/full_screen.1209aba2.svg";